import React from 'react'
import appUtil from '../utils/app.util'

export default function SandboxBadge () {
  if (appUtil.isEnv('production')) return null

  return (
    <span className="inline-flex items-center rounded border border-amber-300 bg-amber-100 px-2 py-1 text-xs font-semibold text-amber-900">
      Sandbox
    </span>
  )
}
